'use strict';

var react = require('react');
require('isomorphic-fetch');
var ReactDOM = require('react-dom');
var PropTypes = require('prop-types');
var dateFns = require('date-fns');
var jsxRuntime = require('react/jsx-runtime');

var AuthContext = /*#__PURE__*/react.createContext({
  token: null,
  error: null,
  expiration: null
});
var useAuthContext = function useAuthContext() {
  return react.useContext(AuthContext);
};

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function read(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += '; ' + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
  }
  function get(key) {
    if (typeof document === 'undefined' || arguments.length && !key) {
      return;
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {}
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set: set,
    get: get,
    remove: function remove(key, attributes) {
      set(key, '', assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function withConverter(converter) {
      return init(assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}
var api = init(defaultConverter, {
  path: '/'
});

var getIframeSrc = function getIframeSrc(_ref) {
  var baseUrl = _ref.baseUrl,
    clientId = _ref.clientId,
    provider = _ref.provider,
    appReferrer = _ref.appReferrer;
  return "".concat(baseUrl, "/").concat(provider, "/passive?client_id=").concat(clientId, "&response_type=code&redirect_uri=").concat(encodeURIComponent(window.location.origin)).concat(appReferrer ? "&app_referrer=".concat(appReferrer) : '');
};
var getSilentIframe = function getSilentIframe(src, provider) {
  var iframe = document.createElement('iframe');
  iframe.id = "".concat(provider, "-passive-auth");
  iframe.style.visibility = 'hidden';
  iframe.style.position = 'fixed';
  iframe.style.left = '-1000px';
  iframe.style.top = '0';
  iframe.width = '0';
  iframe.height = '0';
  iframe.src = src;
  return iframe;
};
var getParams = function getParams(params) {
  var _window$location$sear, _window$location$sear2;
  var searchParams = new URLSearchParams((_window$location$sear = window.location.search) === null || _window$location$sear === void 0 ? void 0 : (_window$location$sear2 = _window$location$sear.substring) === null || _window$location$sear2 === void 0 ? void 0 : _window$location$sear2.call(_window$location$sear, 1));
  try {
    if (typeof params === 'string') {
      return searchParams.get(params);
    } else if (Array.isArray(params)) {
      return Object.fromEntries(Array.from(searchParams.entries()).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          key = _ref3[0];
        return params.includes(key);
      }));
    }
    throw new Error('Params must be an array or an array of strings');
  } catch (error) {
    console.error(error);
    return null;
  }
};

var redirectUriKey = 'cb.auth.redirectUri';
var cbaStorageKey = 'xfinityassistant-bushttps://oauth.xfinity.com/oauth/authorize';
var isDebug = function isDebug() {
  return Boolean(localStorage.getItem('cb.authDebug'));
};
var urlEncode = function urlEncode(object) {
  return Object.entries(object).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
  }).join('&');
};
var PASSIVE_AUTH_STATES = {
  idle: 'idle',
  pending: 'pending',
  rejected: 'rejected',
  skipped: 'skipped',
  authenticated: 'authenticated',
  unauthenticated: 'unauthenticated'
};
var PASSIVE_AUTH_PRIORITY = {
  cima: 1,
  azuread: 2
};
var clearData = function clearData() {
  var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var getLocalStorageKey = function getLocalStorageKey(key) {
    return "cb.auth.".concat(namespace, ".").concat(key);
  };
  localStorage.removeItem(getLocalStorageKey('trackingId'));
  localStorage.removeItem(getLocalStorageKey('accessToken'));
  localStorage.removeItem(getLocalStorageKey('comAuthCore'));
  localStorage.removeItem(getLocalStorageKey('expiration'));
  localStorage.removeItem(cbaStorageKey);
};
function AuthProvider(_ref3) {
  var options = _ref3.options,
    children = _ref3.children;
  var namespace = options.authNamespace || 'default';
  var authProvider = options.authProvider || [];
  var passiveAuthTimeout = typeof options.passiveAuthTimeout === 'number' ? options.passiveAuthTimeout : 5000;
  var initialCodeState = authProvider.reduce(function (state, provider) {
    return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, provider, null));
  }, {});
  var getLocalStorageKey = react.useCallback(function (key) {
    return "cb.auth.".concat(namespace, ".").concat(key);
  }, [namespace]);
  var _useState = react.useState(PASSIVE_AUTH_STATES.idle),
    _useState2 = _slicedToArray(_useState, 2),
    passiveAuthState = _useState2[0],
    setPassiveAuthState = _useState2[1];
  var _useState3 = react.useState(initialCodeState),
    _useState4 = _slicedToArray(_useState3, 2),
    passiveAuthCodeState = _useState4[0],
    setPassiveAuthCodeState = _useState4[1];
  var passiveAuthCodeRef = react.useRef(initialCodeState);
  var _useState5 = react.useState(localStorage.getItem(getLocalStorageKey('comAuthCore'))),
    _useState6 = _slicedToArray(_useState5, 2),
    comAuthCore = _useState6[0],
    setComAuthCore = _useState6[1];
  var _useState7 = react.useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    token = _useState8[0],
    setToken = _useState8[1];
  var _useState9 = react.useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    expiration = _useState10[0],
    setExpiration = _useState10[1];
  var _useState11 = react.useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var onPassiveAuthComplete = react.useCallback(function (e) {
    var _e$data = e.data,
      data = _e$data === void 0 ? {} : _e$data;
    var source = data.source,
      _data$payload = data.payload,
      payload = _data$payload === void 0 ? {} : _data$payload;
    if (source !== 'bsd-passive-auth') {
      return null;
    }
    var authenticated = payload.authenticated,
      code = payload.code,
      provider = payload.provider;
    var newPendingAuthState = _objectSpread2(_objectSpread2({}, passiveAuthCodeState), {}, _defineProperty({}, provider, code));
    if (!authenticated) {
      delete newPendingAuthState[provider];
    }
    setPassiveAuthCodeState(newPendingAuthState);
  }, [passiveAuthCodeState]);
  var login = react.useCallback(function () {
    var encodedUri = window.location.href;
    var appReferrer = sessionStorage.getItem('app_referrer');
    var redirectUri = "".concat(options.baseUrl, "/authorize?client_id=").concat(options.clientId, "&response_type=code&redirect_uri=").concat(encodeURIComponent(encodedUri)).concat(appReferrer ? "&app_referrer=".concat(appReferrer) : '');

    // save current location as cb.auth.redirectUri
    localStorage.setItem(redirectUriKey, encodedUri);

    // redirect to auth service
    window.location = redirectUri;
  }, [options]);
  var logout = react.useCallback(function () {
    // update localStorage
    clearData();

    // update local state
    ReactDOM.unstable_batchedUpdates(function () {
      setError(null);
      setToken(null);
      setExpiration(null);
      setComAuthCore(null);
    });
  }, [setToken, setExpiration, setError, setComAuthCore]);
  var onAuthTimeout = react.useRef(null);
  var fetchToken = react.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(code) {
      var result, response, accessToken, comAuthCoreCookie, expirationSeconds, idToken, redirectUri, expiresIn, expirationTimeout;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (isDebug()) {
              console.log("Fetching token with code ".concat(code, " and redirect_uri ").concat(localStorage.getItem(redirectUriKey)));
            }

            // make token call
            _context.next = 4;
            return fetch("".concat(options.baseUrl, "/token"), {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: urlEncode({
                /* eslint-disable camelcase */
                grant_type: 'authorization_code',
                client_id: options.clientId,
                code: code,
                redirect_uri: localStorage.getItem(redirectUriKey)
                /* eslint-enable camelcase */
              })
            });
          case 4:
            result = _context.sent;
            _context.next = 7;
            return result.json();
          case 7:
            response = _context.sent;
            if (isDebug()) {
              console.log('Got token response');
              console.dir(response);
            }

            // sanity check response
            if (response !== null && response !== void 0 && response.access_token) {
              _context.next = 11;
              break;
            }
            throw new Error('Got token response with no token!');
          case 11:
            accessToken = response.access_token, comAuthCoreCookie = response.com_auth_core, expirationSeconds = response.expires_in, idToken = response.id_token;
            redirectUri = localStorage.getItem(redirectUriKey);
            expiresIn = dateFns.addSeconds(new Date(), expirationSeconds);
            if (isDebug()) {
              console.log("Setting token to ".concat(accessToken));
            }

            // update localStorage
            localStorage.setItem(getLocalStorageKey('trackingId'), api.get('cb_ucid'));
            localStorage.setItem(getLocalStorageKey('accessToken'), accessToken);
            localStorage.setItem(getLocalStorageKey('comAuthCore'), comAuthCoreCookie);
            localStorage.setItem(getLocalStorageKey('expiration'), dateFns.formatISO(expiresIn));
            localStorage.setItem(cbaStorageKey, JSON.stringify({
              accessToken: accessToken,
              idToken: idToken
            }));
            if (options.requireAuthentication) {
              localStorage.removeItem(redirectUriKey);
            }

            // update local state
            ReactDOM.unstable_batchedUpdates(function () {
              setPassiveAuthState(PASSIVE_AUTH_STATES.authenticated);
              setToken(accessToken);
              setExpiration(expiresIn);
              setComAuthCore(comAuthCoreCookie);
              // clear any previous error
              setError(null);
            });
            if (options.requireAuthentication) {
              if (isDebug()) {
                console.log("Finishing redirect to ".concat(redirectUri));
              }

              // complete auth process by redirecting back to previously stored redirectUri
              window.history.replaceState('', '', redirectUri);
            }

            // set expiration timeout
            expirationTimeout = dateFns.differenceInMilliseconds(expiresIn, Date.now()) - 10000;
            if (isDebug()) {
              console.log("Token expires in ~".concat(expirationTimeout, "ms"));
            }
            if (options.requireAuthentication) {
              setTimeout(login, expirationTimeout);
            } else {
              setTimeout(function () {
                // Reauthenticate silently
                setPassiveAuthCodeState(initialCodeState);
                setPassiveAuthState(PASSIVE_AUTH_STATES.idle);
              }, expirationTimeout);
            }
            _context.next = 33;
            break;
          case 28:
            _context.prev = 28;
            _context.t0 = _context["catch"](0);
            setError(_context.t0);
            setPassiveAuthState(PASSIVE_AUTH_STATES.rejected);
            if (isDebug()) {
              console.error(_context.t0);
            }
          case 33:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 28]]);
    }));
    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [login, options.baseUrl, options.clientId, options.requireAuthentication, comAuthCore, getLocalStorageKey]);
  var isPassiveAuthFetchReady = !Object.values(passiveAuthCodeState).includes(null);

  // Keep the ref value in sync with the state value
  react.useEffect(function () {
    passiveAuthCodeRef.current = passiveAuthCodeState;
  }, [passiveAuthCodeState]);
  react.useEffect(function () {
    if (options.requireAuthentication) {
      return null;
    }
    window.addEventListener('message', onPassiveAuthComplete);
    return function () {
      window.removeEventListener('message', onPassiveAuthComplete);
    };
  }, [onPassiveAuthComplete, options.requireAuthentication]);
  react.useEffect(function () {
    if (options.requireAuthentication || !isPassiveAuthFetchReady) {
      return null;
    }
    clearTimeout(onAuthTimeout.current);

    // Filter unauthenticated providers and select based on priority
    var selectedProvider = Object.keys(passiveAuthCodeState).sort(function (curr, prev) {
      return PASSIVE_AUTH_PRIORITY[curr] - PASSIVE_AUTH_PRIORITY[prev];
    })[0];
    if (selectedProvider) {
      fetchToken(passiveAuthCodeState[selectedProvider]);
    } else {
      // When all providers timeout (ie no codes in the state)
      setPassiveAuthState(PASSIVE_AUTH_STATES.unauthenticated);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPassiveAuthFetchReady, options.requireAuthentication]);
  react.useEffect(function () {
    if (getParams('code') && localStorage.getItem(redirectUriKey)) {
      fetchToken(getParams('code'));
    } else if (options.requireAuthentication) {
      var rawToken = localStorage.getItem(getLocalStorageKey('accessToken'));
      var rawExpiration = dateFns.parseISO(localStorage.getItem(getLocalStorageKey('expiration')));
      var validToken = Boolean(rawToken) && api.get('cb_ucid') === localStorage.getItem(getLocalStorageKey('trackingId')) && dateFns.isBefore(Date.now(), rawExpiration);
      if (!validToken) {
        login();
      } else {
        // set expiration timeout
        var expirationTimeout = dateFns.differenceInMilliseconds(rawExpiration, Date.now()) - 10000;
        if (isDebug()) {
          console.log("Token expires in ~".concat(expirationTimeout, "ms"));
        }
        setTimeout(login, expirationTimeout);

        // set token and expiration in context
        ReactDOM.unstable_batchedUpdates(function () {
          setToken(rawToken);
          setExpiration(rawExpiration);
        });
      }
    }
  }, [login, options, comAuthCore, fetchToken, getLocalStorageKey]);

  // Use silent authentication
  react.useEffect(function () {
    // Do not start passive auth if we are waiting for a code
    if (getParams('code') && localStorage.getItem(redirectUriKey)) {
      return null;
    }

    // Don't start passive auth if it's already started
    if (options.requireAuthentication || passiveAuthState !== PASSIVE_AUTH_STATES.idle) {
      return null;
    }

    // Don't start passive auth if the user-agent is a known bot
    var userAgent = window.navigator.userAgent;
    if (userAgent.includes('Nutch') || userAgent.includes('Googlebot')) {
      setPassiveAuthState(PASSIVE_AUTH_STATES.skipped);
      return null;
    }
    setPassiveAuthState(PASSIVE_AUTH_STATES.pending);
    // Clear previous timeout for token refresh
    clearTimeout(onAuthTimeout.current);
    onAuthTimeout.current = setTimeout(function () {
      // Omit null values to fetch token when authentication times out
      var filteredCodeState = Object.keys(passiveAuthCodeRef.current).reduce(function (acc, curr) {
        // cleanup iframe that is still pending
        if (passiveAuthCodeRef.current[curr] === null) {
          document.getElementById("".concat(curr, "-passive-auth")).remove();
        }
        return _objectSpread2(_objectSpread2({}, acc), passiveAuthCodeRef.current[curr] !== null ? _defineProperty({}, curr, passiveAuthCodeRef.current[curr]) : {});
      }, {});
      setPassiveAuthCodeState(filteredCodeState);
    }, passiveAuthTimeout);
    var providers = Object.keys(passiveAuthCodeState);
    var appReferrer = sessionStorage.getItem('app_referrer');
    providers.forEach(function (provider) {
      // Cleanup previously mounted iframe for token refresh
      var prevIframe = document.getElementById("".concat(provider, "-passive-auth"));
      if (prevIframe) {
        prevIframe.remove();
      }

      // Get passive auth iframes
      var src = getIframeSrc({
        baseUrl: options.baseUrl,
        clientId: options.clientId,
        provider: provider,
        appReferrer: appReferrer
      });
      var iframe = getSilentIframe(src, provider);

      // Append iframe to the document
      document.body.appendChild(iframe);
    });
  }, [passiveAuthCodeState, fetchToken, options.clientId, options.baseUrl, options.requireAuthentication, passiveAuthTimeout, passiveAuthState]);
  if (options.requireAuthentication === null) {
    throw new Error('Must supply requireAuthentication boolean!');
  }
  return /*#__PURE__*/jsxRuntime.jsx(AuthContext.Provider, {
    value: {
      authState: passiveAuthState,
      login: login,
      logout: logout,
      token: token,
      comAuthCore: comAuthCore,
      error: error,
      expiration: expiration
    },
    children: children
  });
}
AuthProvider.propTypes = {
  options: PropTypes.object,
  children: PropTypes.node.isRequired
};

exports.AuthProvider = AuthProvider;
exports.PASSIVE_AUTH_STATES = PASSIVE_AUTH_STATES;
exports.clearData = clearData;
exports.useAuthContext = useAuthContext;
//# sourceMappingURL=index.js.map
